import React from "react";
import cns from "classnames";
import CircularProgress, {
  CircularProgressProps
} from "@material-ui/core/CircularProgress";
import { animation } from "polished";
import { ThemeType } from "@theme";
import { makeStyles } from "@material-ui/core/styles";

export type SpinnerProps = {
  [other: string]: any;
  color?: CircularProgressProps["color"];
  className?: string;
  size?: number | string;
  inline?: boolean;
  fullHeight?: boolean;
};

export function Spinner(props: SpinnerProps) {
  const { className, color = "primary", inline, fullHeight, show, size, ...rest } = props;
  const classes = useStyles({});

  if (inline) {
    return <CircularProgress color={color} size={size} {...rest} />;
  }

  return (
    <div
      className={cns(classes.root, className, { [classes.fullHeight]: fullHeight })}
      {...rest}
    >
      <CircularProgress color={color} size={size} />
    </div>
  );
}

const useStyles = makeStyles((theme: ThemeType) => ({
  root: {
    alignItems: "center",
    display: "flex",
    flex: 1,
    justifyContent: "center"
  },

  fullHeight: { height: "100%" },

  icon: {
    transform: "scale(-1, 1)",
    height: theme.typography.fontSize * 2,
    width: theme.typography.fontSize * 2,
    ...(animation(["spin", "1s", "infinite", "linear"]) as any)
  }
}));
